module.exports = __webpack_public_path__ + "static/media/config-edit.9b9465d0.png";